import type { ShellUser } from './types'

/** Platzhalter, den die Module bisher bei fehlendem Namen übergeben haben. */
const PLATZHALTER = 'Benutzer'

/** Anzeigename: Name, sonst Benutzername, sonst "Benutzer". */
export function resolveUserName(user: ShellUser): string {
  const name = (user.name ?? '').trim()
  const username = (user.username ?? '').trim()
  if (username && (!name || name === PLATZHALTER)) return username
  return name || PLATZHALTER
}
